import React from 'react';
import { NavLink } from 'react-router-dom';

// One nav group: header (icon+label, hidden when collapsed) + its item list
// (icon+label rows, label hidden when collapsed — icon-only rail look).
// Renders nothing if `items` is empty (mirrors the old Navbar's per-section
// hasAnyDropdownSection gating, just computed per-group instead of once globally).
export default function SidebarGroup({ group, items, collapsed, badgeValues = {}, onItemClick }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="mb-1">
      {group && (
        <div
          className="d-flex align-items-center gap-2 text-uppercase"
          style={{ fontSize: 11, fontWeight: 600, color: '#8b98a9', letterSpacing: '0.05em', padding: collapsed ? '10px 0 4px' : '14px 16px 4px', justifyContent: collapsed ? 'center' : 'flex-start' }}
          title={collapsed ? group.label : undefined}
        >
          {group.icon && <group.icon size={13} />}
          {!collapsed && <span>{group.label}</span>}
        </div>
      )}
      {items.map(item => {
        const badgeCount = item.badge ? badgeValues[item.badge] : 0;
        return (
          <NavLink
            key={item.id}
            to={item.path}
            onClick={onItemClick}
            title={collapsed ? item.label : undefined}
            className={({ isActive }) =>
              `d-flex align-items-center text-decoration-none position-relative ${isActive ? 'text-white' : ''}`
            }
            style={({ isActive }) => ({
              gap: 10,
              padding: collapsed ? '9px 0' : '9px 16px',
              justifyContent: collapsed ? 'center' : 'flex-start',
              fontSize: 14,
              color: isActive ? '#fff' : '#c3ccd6',
              background: isActive ? 'rgba(255,255,255,0.08)' : 'transparent',
              borderRight: isActive ? '2px solid #4dabf7' : '2px solid transparent',
            })}
          >
            {item.icon && <item.icon size={16} style={{ flexShrink: 0 }} />}
            {!collapsed && <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.label}</span>}
            {badgeCount > 0 && (
              <span
                className="badge rounded-pill bg-danger"
                style={{ fontSize: 10, ...(collapsed ? { position: 'absolute', top: 2, right: 'calc(50% - 16px)' } : { marginLeft: 'auto' }) }}
              >
                {badgeCount > 99 ? '99+' : badgeCount}
              </span>
            )}
          </NavLink>
        );
      })}
    </div>
  );
}
